import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const CopdIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path
        d="M18.3 7.5c-.7-.7-1.6-1.1-2.6-1-.7.1-1.3.5-1.7 1.2-.1.2-.2.4-.3.7 0 .1-.1.2-.1.3-.1.1-.2.2-.3.4-.2.1-.4.3-.6.4V2.3c0-.3-.3-.6-.6-.6s-.6.3-.6.6v7.2c-.3-.1-.6-.4-.8-.6 0-.1-.1-.1-.2-.2s-.1-.2-.1-.3c-.1-.2-.2-.4-.3-.7-.3-.6-1-1.1-1.7-1.2-1-.1-1.9.3-2.6 1-2.5 2.4-4 5.7-4.2 9.2 0 1.3-.1 4.2 2.1 5.1.8.3 1.6.4 2.4.4 1 0 1.9-.2 2.8-.6.9-.3 1.5-1 1.9-1.9.2-.7.3-1.5.2-2.2 0-.5.1-1 .2-1.6v.1c.5-.1.9-.2 1.4-.1v.2c.2.5.3 1 .4 1.6-.1.8 0 1.5.2 2.3.3.9 1 1.5 1.9 1.9.9.4 1.8.6 2.8.6.8 0 1.6-.1 2.4-.4 2.2-.9 2.2-3.9 2.1-5.1-.2-3.7-1.6-7-4.1-9.5z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </IconBase>
  );
};

export default CopdIcon;
